import React, { useEffect, useState } from 'react';
import { Container, Stack } from 'react-bootstrap';
import DownloadStassifyApp from 'components/Home/DownloadStassifyApp';
import { useStaticPagesQuery } from 'services';
import { getStaticPages } from 'utils';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'utils/sanitizeHtml';
import useTranslate from 'hooks/useTranslate';
import '../styles.scss';
import useLocalizationStore from 'store/localization';

export const About: React.FC = () => {
	const { translate } = useTranslate();
	const { activeLanguage }: any = useLocalizationStore((state) => state);
	const { data, refetch } = useStaticPagesQuery();
	const [dataToShow, setDataToShow] = useState<any>(undefined);

	useEffect(() => {
		const staticData = getStaticPages(data, 'about');
		setDataToShow(staticData);
	}, [data]);

	useEffect(() => {
		refetch();
	}, [activeLanguage]);

	return (
		<section className="static-page bg-white">
			<div className="static-page-banner">
				<div className="static-page-banner-bg privacy-banner h-100 w-100 d-flex align-items-center justify-content-center position-relative">
					<div className="static-page-banner-bg-overlay w-100 h-100 position-absolute top-0 left-0"></div>
					<h2 className="fw-bold text-white mb-0">{dataToShow?.title}</h2>
				</div>
			</div>
			<Container>
				<div className="static-page-content py-80">
					{!dataToShow ? (
						<div className="inner-page-content-box" style={{ height: '500px' }}>
							{' '}
						</div>
					) : (
						<div className="inner-page-content-box">
							{!dataToShow?.description ? (
								<Stack style={{ textAlign: 'center' }}>{translate('Common.noDataFound')}</Stack>
							) : (
								parse(sanitizeHtml(dataToShow?.description?.replace(/\n/g, '<br>')))
							)}
						</div>
					)}
				</div>
			</Container>
			<DownloadStassifyApp />
		</section>
	);
};

export default About;
